export const ActionTypes = {
  editDeckCards: "[Deck] Edit Deck Cards",
  editDeckNumber: "[Deck] Edit Deck Number",
  editCondition: "[Config] Edit Condition",
  editNumberToDraw: "[Config] Edit Number To Draw",
  run: "[Sim] Run simulation",
} as const;
